import React, { useEffect } from "react";
import { useToaster } from "../../context/ToasterContext";
import "./Toaster.scss";
import { ReactComponent as CheckCircleIcon } from "../../assets/icons/check-circle.svg";
import { ReactComponent as ExclamationCircleIcon } from "../../assets/icons/exclaimation-circle.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const Toaster = () => {
  const { toasts, removeToast } = useToaster();

  // Auto-dismiss toast after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      if (toasts.length > 0) {
        removeToast(toasts[0].id);
      }
    }, 7000);

    return () => clearTimeout(timer);
  }, [toasts, removeToast]);

  return (
    <div
      aria-live="polite"
      className="toaster-wrapper"
      style={{ zIndex: 1050 }}
    >
      {toasts.map((toast) => (
        <div
          className={`alert alert-${toast.type} alert-dismissible`}
          key={toast.id}
        >
          {toast.type === 'success' &&
            <div className="bgIcon">
              <CheckCircleIcon />
            </div>
          }
          {toast.type === 'danger' &&
            <div className="bgIcon">
              <ExclamationCircleIcon />
            </div>
          }
          <p>{toast.message}</p>
          <button
            type="button"
            className="pool-btn-close"
            onClick={(e) => {
              e.stopPropagation();
              removeToast(toast.id);
            }}
          >
            <CloseIcon></CloseIcon>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toaster;
